export interface TcPageState {
  pageInfo: IPageState;
}

export interface IPageState {
  title: string;
}

export const getPageInfo = (state: TcPageState) => state.pageInfo;
